export function getSuccessMessage(state) {
	return state.success;
}
